import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import HisabBook_Hero from "./HisabBook_Hero/HisabBook_Hero";
import HisabBook_Service from "./HisabBook_ServiceSection/HisabBook_ServiceSection";
import HisabBook_Feature from "./HisabBook_Feature/HisabBook_Feature";
import HisabBook_Testimonial from "./HisabBook_Testimonial";
import HisabBook_Counter_Exp from "./HisabBook_Counter_Exp/HisabBook_Counter_Exp";
import HisabBook_Faq from "./HisabBook_FAQ/HisabBook_FAQ";
import Footer from "../../Components/Footer/Footer";

const SchoolMS = () => {
  return (
    <div>
      <Navbar></Navbar>
      <HisabBook_Hero></HisabBook_Hero>
      <HisabBook_Service></HisabBook_Service>
      {/* <HisabBook_Testimonial></HisabBook_Testimonial> */}
      <HisabBook_Counter_Exp></HisabBook_Counter_Exp>
      <HisabBook_Faq></HisabBook_Faq>
      <Footer></Footer>
    </div>
  );
};

export default SchoolMS;
